// Modules
import { destroy } from 'redux-form';
import store from 'app-store';
import { mergeQueryReplace } from 'modules/history/actions';
import { REMOVE_FILTERS } from './action-types';

export function setDefaultQuery(defaults) {
  mergeQueryReplace({ where: defaults || {} });
}

export function removeFilters() {
  store.dispatch({ type: REMOVE_FILTERS });
  // Destroy the filterForm section of the store when removing filters. We can't let this happen
  // on unmount (as is the default for redux forms), because the filter form is unmounted when the user switches
  // tabs or closes the right pane, & the user would lose any changes to filters that they hadn't
  // applied
  store.dispatch(destroy('filterForm'));
}
